module.exports = __webpack_public_path__ + "img/reaper.0b890ffc.jpg";